import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";

import CheckList, { ListInterface } from "../CheckList";
import { UserGroupUserPermission } from "api/interfaces/userInterface.interface";
import { useMemo } from "react";
import { useDwPermission } from "hook/useDwPermission";
import { useFlag } from "@unleash/proxy-client-react";

interface Props {
  userCheckedList: UserGroupUserPermission;
  userDisabledList: UserGroupUserPermission;
  onChangeDwPermission: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function DwPermissionCheckList(props: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const userCheckedList: Record<string, boolean> = useMemo(() => {
    const { groupName, ...rest } = props.userCheckedList;
    return rest;
  }, [props.userCheckedList]);

  const userDisabledList: Record<string, boolean> = useMemo(() => {
    const { groupName, ...rest } = props.userDisabledList;
    return rest;
  }, [props.userDisabledList]);

  const { accountLevelRenderingArray } = useDwPermission({});

  const renderCheckLists = (lists: Array<ListInterface[]>) => {
    return (
      <>
        {lists.map((list, index) => (
          <CheckList
            key={index}
            list={list}
            isCheck={userCheckedList}
            isDisabled={userDisabledList}
            onCheckedElement={props.onChangeDwPermission}
          />
        ))}
      </>
    );
  };

  const accountLevelRendering =
    accountLevelRenderingArray[selectedAccount.accountLevelExtendSubCp];

  return renderCheckLists(accountLevelRendering);
}

export default DwPermissionCheckList;
